import { ReactNode } from 'react';
import { AppHeader } from './AppHeader';
import { AppSidebar } from './AppSidebar';
import { MobileNav } from './MobileNav';

interface AppLayoutProps {
  children: ReactNode;
  title?: string;
  showNavigation?: boolean;
}

/**
 * Responsive App-Shell:
 * - ab md: feste linke Sidebar (alle Ziele + Konto), Inhalt mit Rand links.
 * - darunter: Marken-Header oben (mit Konto-Ecke) + Bottom-Bar/„Mehr" unten.
 * Eine Quelle für die Ziele: config/navigation.tsx.
 */
export function AppLayout({ children, title, showNavigation = true }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      {showNavigation && <AppSidebar />}
      <div className={showNavigation ? 'md:pl-64' : ''}>
        <AppHeader title={title} />
        <main className={`flex-1 ${showNavigation ? 'pb-24 md:pb-10' : ''}`}>
          {children}
        </main>
      </div>
      {showNavigation && <MobileNav />}
    </div>
  );
}
